import { assign } from 'lodash';
import * as actions from './actions';

export default (context, dispatcher, update) => assign(context, {
  // public functions
  closeWindow: data => dispatcher.notify(actions.CLOSE_WINDOW, { data }),

  showWebView: (url, title, onClose, config) =>
    dispatcher.notify(actions.SHOW_WEBVIEW, { url, title, onClose, config }),

  sendGoogleAnalyticsEvent: (category, action, label, value) =>
    dispatcher.notify(actions.SEND_GOOGLEAN_ALYTICS_EVENT, { category, action, label, value }),

  showProduct: productSelection =>
    dispatcher.notify(actions.SHOW_PRODUCT, { productSelection }),

  showCategory: (title, id, isLeaf) =>
    dispatcher.notify(actions.SHOW_CATEGORY, { title, id, isLeaf }),

  selectProductFromModalCatalog: (title, id, isLeaf, callback) =>
    dispatcher.notify(actions.SELECT_PRODUCT_FROM_MODAL_CATALOG, { title, id, isLeaf, callback }),

  showCustomer: customerSearchParams =>
    dispatcher.notify(actions.SHOW_CUSTOMER, { customerSearchParams }),

  setWindowTitle: title => dispatcher.notify(actions.SET_WINDOW_TITLE, { title }),

  createOrder: orderData => dispatcher.notify(actions.CREATE_ORDER, { orderData }),

  showCustomerInfoModal: customerId =>
    dispatcher.notify(actions.SHOW_CUSTOMER_INFO_MODAL, { customerId }),

  // note that listType is optional
  showCustomerSelectionModal: (callback, listType) =>
    dispatcher.notify(actions.SHOW_CUSTOMER_SELECTION_MODAL, { callback, listType }),

  signIntoGoogle: (successCallback, failureCallback, permissions) =>
    dispatcher.notify(actions.SIGN_IN_TO_GOOGLE, { successCallback, failureCallback, permissions }),

  disconnectFromGoogle: (successCallback, failureCallback) =>
    dispatcher.notify(actions.DISCONNECT_FROM_GOOGLE, { successCallback, failureCallback }),

  signOutFromGoogle: () =>
    dispatcher.notify(actions.SIGN_OUT_FROM_GOOGLE),

  addLeftNavBarButton: (title, callback, index) =>
    dispatcher.notify(actions.ADD_LEFT_NAVBAR_BUTTON, { title, callback, index }),

  addRightNavBarButton: (title, callback, index) =>
    dispatcher.notify(actions.ADD_RIGHT_NAVBAR_BUTTON, { title, callback, index }),

  removeLeftNavBarButton: index =>
    dispatcher.notify(actions.REMOVE_LEFT_NAVBAR_BUTTON, { index }),

  removeRightNavBarButton: index =>
    dispatcher.notify(actions.REMOVE_RIGHT_NAVBAR_BUTTON, { index }),

  requestNewTulipAuthToken: (callback) => {
    dispatcher.request(actions.REQUEST_NEW_TULIP_AUTH_TOKEN).then(async (token) => {
      await update();

      if (callback) {
        callback(token);
      }
    });
  },

  userAssociationsUpdated: () =>
    dispatcher.notify(actions.USER_ASSOCIATIONS_UPDATED),

  customerActivityLogUpdated: () =>
    dispatcher.notify(actions.CUSTOMER_ACTIVITY_LOG_UPDATED),

  editCustomerModal: () =>
    dispatcher.notify(actions.EDIT_CUSTOMER_MODAL),

  callCustomer: (phone, callback) =>
    dispatcher.notify(actions.CALL_CUSTOMER, { phone, callback }),
});



// WEBPACK FOOTER //
// ./src/WebBridge/createBridge.js